import { IActionFind, IActionLoadPatient, IActionUpdate, PatientTypes } from './types'
import { all, apply, call, put, takeLatest } from 'redux-saga/effects'
import { IActionType, IAxiosResponse } from '../root.types'
import {
    loadPatientSuccess,
    loadPatientFailure,
    findPatientFailure,
    findPatientSuccess,
    updatePatientSuccess,
    updatePatientFailure,
    createPatientSuccess,
    createPatientFailure,
    removeAvatarFailure,
    changeAvatarFile,
    removeAvatarSuccess,
    loadAvatarFailure,
    loadAvatarSuccess,
} from './actions'
import patientService from "../../../services/patient"
// import moment from 'moment'
import { Patient } from '../../application/models/patient/patient'
import { SnackBarMessageType } from '../../../components/layout/snackbar/index'
import { open } from '../snack.bar/actions'
import { push } from 'connected-react-router'
import avatarService from '../../../services/avatar'

const type: string = "patients"

function* loadPatient(action: IActionType<IActionLoadPatient>) {
    try {
        const { paginator } = action.payload
        const patient: IAxiosResponse<Patient[]> = yield apply(
            patientService,
            patientService.getAll,
            [paginator]
        )
        yield put(loadPatientSuccess(patient))
    } catch (e) {
        yield put(loadPatientFailure())
    }
}

function* findPatient(action: IActionType<IActionFind>) {
    try {
        const { patientId } = action.payload
        const patient: IAxiosResponse<Patient> = yield apply(
            patientService,
            patientService.getById,
            [patientId]
        )
        yield put<any>(findPatientSuccess(patient))
    } catch (e) {
        yield put(findPatientFailure())
    }
}

function* updatePatient(action: IActionType<IActionUpdate>) {
    try {
        const { patient, avatar } = action.payload
        const patients: IAxiosResponse<Patient> = yield apply(
            patientService,
            patientService.updadePatient,
            [patient]
        )
        if (patients.data.id && avatar?.name) {
            yield call(saveAvatar, patients.data.id, avatar)
        }
        yield put<any>(updatePatientSuccess(patients))
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Salvo paciente com sucesso`)
        )
    } catch (e: any) {
        if (e.code === 409) {
            yield put(
                open(
                    SnackBarMessageType.ERROR,
                    'Erro ao salvar paciente',
                    `CPF já registrado no sistema`)
            )
        }
        else {
            yield put(
                open(
                    SnackBarMessageType.ERROR,
                    '',
                    `Erro ao salvar paciente`)
            )
        }

        yield put(updatePatientFailure())
    }
}
function* createPatient(action: IActionType<IActionUpdate>) {
    try {
        const { patient, avatar } = action.payload
        const newPatient: IAxiosResponse<Patient> = yield apply(
            patientService,
            patientService.create,
            [patient]
        )
        if (newPatient.data.id && avatar?.name) {
            yield call(saveAvatar, newPatient.data.id, avatar)
        }
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Salvo paciente com sucesso`)
        )
        yield put<any>(createPatientSuccess(newPatient))
        yield put(push(`/app/home/${newPatient.data.id}/followups`))

    } catch (e: any) {
        if (e.code === 409) {
            yield put(
                open(
                    SnackBarMessageType.ERROR,
                    'Erro ao salvar paciente',
                    `CPF já registrado no sistema`)
            )
        }
        else {
            yield put(
                open(
                    SnackBarMessageType.ERROR,
                    '',
                    `Erro ao salvar paciente`)
            )
        }
        yield put(createPatientFailure())
    }
}

function* saveAvatar(patientId: string, avatar: any) {
    if (avatar) {
        yield apply(avatarService, avatarService.save, [patientId, avatar, type])
    }
}

function* getAvatar(action: IActionType<IActionFind>) {
    const { patientId } = action.payload
    try {
        const response: any = yield apply(avatarService, avatarService.get, [patientId, type])
        yield put<any>(loadAvatarSuccess(response))
    } catch (e) {
        yield put(loadAvatarFailure())
    }
}

function* removeAvatar(action: IActionType<IActionFind>) {
    const { patientId } = action.payload
    try {
        yield apply(avatarService, avatarService.remove, [patientId, type])
        yield put<any>(removeAvatarSuccess())
        yield put(open(SnackBarMessageType.SUCCESS, '', 'SNACKBAR.REMOVE.AVATAR'))
        yield put(changeAvatarFile())

    } catch (e) {
        yield put(removeAvatarFailure())
    }
}

export default function* patientSaga() {
    return yield all([
        takeLatest(PatientTypes.CREATE_PATIENT_REQUEST, createPatient),
        takeLatest(PatientTypes.LOAD_PATIENT_REQUEST, loadPatient),
        takeLatest(PatientTypes.FIND_PATIENT_REQUEST, findPatient),
        takeLatest(PatientTypes.UPDATE_PATIENT_REQUEST, updatePatient),
        takeLatest(PatientTypes.CHANGE_SEARCH, loadPatient),
        takeLatest(PatientTypes.LOAD_AVATAR_REQUEST, getAvatar),
        takeLatest(PatientTypes.REMOVE_AVATAR_REQUEST, removeAvatar),
    ])
}

